import type {InteractiveActivityBlock,InteractiveAssetRef} from './interactive-activity';
import {resourceForAsset} from './interactive-resources';
import {resourcePresentationUrl} from './resource-presentation';

export function activityPdfResource(block:InteractiveActivityBlock,assets:InteractiveAssetRef[]=[]):string|undefined{
 if(!['animation','simulation','video'].includes(block.type)||!('assetId' in block))return;
 const asset=assets.find(a=>a.id===block.assetId);
 if(!asset)return;
 const resource=resourceForAsset(asset);
 if(resource?.resourceId==='measurement-and-titration')return resource.url;
 if(resource){try{
  const url=new URL(resourcePresentationUrl(resource,'resourceConfig' in block?block.resourceConfig:undefined),'https://placeholder.invalid');
  if(url.searchParams.has('config')){
   const config=JSON.parse(url.searchParams.get('config')!);
   const changes=Object.fromEntries(Object.entries(config).filter(([key,value])=>JSON.stringify(value)!==JSON.stringify(resource.defaultConfig?.[key])));
   if(Object.keys(changes).length)url.searchParams.set('config',JSON.stringify(changes));else url.searchParams.delete('config');
  }
  return url.pathname+url.search;
 }catch{return resource.url;}}
 const url=asset.url;
 if(url&&(/^(https?:\/\/|\/(?!\/))/.test(url)))return url;
}
